import { Mixins, Prop, Component } from 'vue-property-decorator';
import { StaticPageMixin } from '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let StaticPageContentComponent = class extends Mixins(StaticPageMixin) {
  get topNav() {
    return this.variant === "top-nav";
  }
  scrollToHash() {
    if (window.location.hash && this.content && this.$refs.text) {
      const elem = this.$refs.text.shadowRoot.querySelector(window.location.hash);
      if (elem) {
        elem.scrollIntoView();
      }
    }
  }
};
__decorateClass([
  Prop(String)
], StaticPageContentComponent.prototype, "variant", 2);
StaticPageContentComponent = __decorateClass([
  Component({
    name: "static-page-content"
  })
], StaticPageContentComponent);

export default StaticPageContentComponent;
